import React, { useState } from 'react';
import { Upload, Button, Modal, message, Table, Tooltip } from 'antd';
import { UploadOutlined, InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Papa from 'papaparse';

const CSVTable = ({ data }) => {
  const columns = Object.keys(data[0] || {}).map(key => ({
    title: key,
    dataIndex: key,
    key,
  }));

  return <Table dataSource={data} columns={columns} pagination={false} />;
};

const PortfolioImport = ({ asModal = false }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [csvData, setCsvData] = useState([]);
  // Dynamically adjust modal size based on content, with a max width
  const modalWidth = Math.min(600, 200 + csvData.length * 100);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setCsvData([]); // Clear data on modal close to reset the state
  };

  const beforeUpload = (file) => {
    const isCSV = file.type === 'text/csv';
    if (!isCSV) {
      message.error('You can only upload CSV file!');
      return Upload.LIST_IGNORE;
    }

    Papa.parse(file, {
      header: true, // Assumes the CSV file has a header row
      complete: (results) => {
        console.log('Parsed Results: ', results);
        setCsvData(results.data); // Store parsed data in state
        message.success('CSV file successfully processed!');
      },
    });
    return false; // Stop auto-upload
  };

  const portfolioImportContent = (
    <>
      <Upload beforeUpload={beforeUpload} showUploadList={false}>
        <Button icon={<UploadOutlined />}>Click to Upload</Button>
      </Upload>
      <Tooltip title="Click here to see the expected file format">
        <Button onClick={showModal} icon={<InfoCircleOutlined />}>
          Format Example
        </Button>
      </Tooltip>
      {csvData.length > 0 && <CSVTable data={csvData} />}
    </>
  );

  return (
    <>
      {asModal ? (
        <>
          <Button onClick={showModal} type="primary">
            Import Portfolio
          </Button>
          <Modal title="Import Portfolio" visible={isModalVisible} onOk={handleOk} onCancel={handleOk} footer={null} width={modalWidth}>
            {portfolioImportContent}
          </Modal>
        </>
      ) : (
        <div>
          {portfolioImportContent}
          <Modal title="File Format Example" visible={isModalVisible} onOk={handleOk} onCancel={handleOk} footer={null}>
            <p>CSV file should contain columns like:</p>
            <p>Symbol or Ticker (e.g., AAPL), Weight or Percentage (e.g., 10.5%), etc.</p>
            <p>Example:</p>
            <p>AAPL, 10.5%</p>
            <p>MSFT, 20%</p>
            <Tooltip title="Ensure the first row includes column headers for proper parsing">
              <QuestionCircleOutlined />
            </Tooltip>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PortfolioImport;
